import React from 'react';

const PauseVideoButton: React.FC = props => (
  <svg
    width="88"
    height="60"
    viewBox="0 0 88 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="88" height="60" fill="#2277D1" fillOpacity="0.8" />
    <path
      d="M41.3333 19.3333H36V40.6667H41.3333V19.3333Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.9974 19.3333H46.6641V40.6667H51.9974V19.3333Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PauseVideoButton;
